import * as z from "zod/v4";
import { SLUG_REGEXP, toSlug } from "../util/slug.ts";

export const SlugSchema = z
  .string()
  .regex(
    SLUG_REGEXP,
    "Slug must be lowercase word characters and dashes (e.g., 'my-note-slug')",
  );

export type Slug = z.infer<typeof SlugSchema>;

export const CoerceSlugSchema = z.preprocess(
  (v) => (typeof v === "string" ? (toSlug(v) ?? v) : v),
  SlugSchema,
);

export const CoerceSlugsSchema = z.preprocess(
  (v) =>
    Array.isArray(v)
      ? v.flatMap((s) =>
          typeof s === "string" ? (toSlug(s) ? [toSlug(s)!] : []) : [],
        )
      : v,
  z.array(SlugSchema),
);
